const module = {
  config: {
    name: 'voting-module',
    icon: 'ri-user-line',
    desc: '',
    group: 'Forum',
    layout: true
  },
  routes: [
    { name: 'voting', label: 'Voting', icon: 'ri-pushpin-2-line', path: '/voting', component: () => import('./config-votings.vue') }
    // { name: 'voting', label: 'Berita', icon: 'ri-skip-right-fill', path: '/voting', component: () => import('./config-votings.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/voting/_index.js